<div class="modal-header">
  <h5 class="modal-title">{{ itemId ? 'რედაქტირება' : 'დამატება' }}</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div *ngIf="loading" class="py-2">
    <span class="spinner-border spinner-border-sm"></span> იტვირთება...
  </div>

  <div *ngIf="!loading">
    <div class="mb-3">
      <label class="form-label">სათაური</label>
      <input class="form-control" [(ngModel)]="model.title" />
    </div>

    <div class="mb-3">
      <label class="form-label">URL</label>
      <input class="form-control" [(ngModel)]="model.url" placeholder="https://sca.ge/geo/static/506" />
    </div>

    <div class="mb-3">
      <label class="form-label">Target</label>
      <select class="form-select" [(ngModel)]="model.target">
        <option [ngValue]="'_self'">_self</option>
        <option [ngValue]="'_blank'">_blank</option>
      </select>
    </div>

    <div class="mb-3">
      <label class="form-label">გამოჩენა</label>
      <select class="form-select" [(ngModel)]="model.visible">
        <option [ngValue]="1">ჩანს</option>
        <option [ngValue]="0">არ ჩანს</option>
      </select>
    </div>

    <!-- სურათი/ზომები intentionally არ გვაქვს -->
    <div class="alert alert-secondary mb-0">
      სურათი/ზომები გამორთულია — ინახება NULL.
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-light" (click)="activeModal.dismiss()">დახურვა</button>
  <button class="btn btn-primary" (click)="save()" [disabled]="saving">
    <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
    შენახვა
  </button>
</div>